module.exports = __webpack_public_path__ + "static/FIBONACCI_SCENE3_SHOT2_LOOP-392fb6903ded6e9953f100bafd25ec46.mp4";